if (!customElements.get('testimonials-component')) {
  class Testimonials extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.selectors = {
        sliderWrapper: '.testimonials__items',
        pagination: '.swiper-pagination',
        nextEl: '.swiper-btn-next',
        prevEl: '.swiper-btn-prev',
      };
      this.classes = {
        grid: 'f-grid',
        swiper: 'swiper',
        swiperWrapper: 'swiper-wrapper',
      };

      this.sectionId = this.dataset.sectionId;
      this.section = this.closest(`.section-${this.sectionId}`);
      this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);

      this.enableSlider = this.dataset.enableSlider === 'true';
      this.items = parseInt(this.dataset.items);
      this.tabletItems = parseInt(this.dataset.tabletItems);

      this.sliderInstance = false;

      // GESTION DU CLIC : Correction pour forcer l'agrandissement réel
      this.addEventListener('click', (e) => {
        const btn = e.target.closest('[data-read-more]');
        if (!btn) return;

        const container = btn.closest('.testimonial__text-container');
        const textContent = container.querySelector('[data-testimonial-text]');
        const isExpanded = textContent.classList.contains('is-expanded');
        
        // On bascule l'état
        if (isExpanded) {
          textContent.classList.remove('is-expanded');
          btn.textContent = "Lire plus";
        } else {
          textContent.classList.add('is-expanded');
          btn.textContent = "Réduire";
        }

        // RECALCUL RADICAL DU SLIDER
        if (this.sliderInstance && this.sliderInstance.slider) {
          const swiper = this.sliderInstance.slider;
          
          // On laisse le temps au CSS de s'appliquer
          setTimeout(() => {
            // On force la hauteur de l'autoHeight sur le slide actif
            if (swiper.params.autoHeight) {
              swiper.updateAutoHeight(300);
            }
            swiper.update(); // Met à jour la structure
          }, 100);
        }
      });

      // AFFICHAGE DU BOUTON : Vérification après rendu
      setTimeout(() => {
        this.querySelectorAll('.testimonial__text-container').forEach(container => {
          const text = container.querySelector('[data-testimonial-text]');
          const btn = container.querySelector('[data-read-more]');
          // On compare scrollHeight (taille réelle) vs clientHeight (taille visible bridée à 4 lignes)
          if (text.scrollHeight > text.clientHeight + 2) {
            btn.style.display = 'inline-block';
          }
        });
      }, 800);

      if (!this.enableSlider) return;

      this.init();
      document.addEventListener('matchMobile', () => this.init());
      document.addEventListener('unmatchMobile', () => this.init());
    }

    init() {
      if (FoxTheme.config.mqlMobile) {
        this.destroySlider();
      } else {
        this.initSlider();
      }
    }

    initSlider() {
      const columnGap = window.getComputedStyle(this.sliderWrapper).getPropertyValue('--column-gap');
      const spaceBetween = parseFloat(columnGap.replace('rem', '')) * 10;

      const sliderOptions = {
        modules: [FoxTheme.Swiper.Navigation, FoxTheme.Swiper.Pagination],
        slidesPerView: 2,
        spaceBetween: spaceBetween,
        autoHeight: true, // IMPORTANT
        navigation: {
          nextEl: this.section.querySelector(this.selectors.nextEl),
          prevEl: this.section.querySelector(this.selectors.prevEl),
        },
        pagination: false,
        breakpoints: {
          768: { slidesPerView: this.tabletItems > 3 ? 3 : parseInt(this.tabletItems) },
          1280: { slidesPerView: parseInt(this.items) },
        },
        loop: true,
        threshold: 2,
      };

      if (typeof this.sliderInstance !== 'object') {
        this.classList.add(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.grid);
        this.sliderWrapper.classList.add(this.classes.swiperWrapper);
        this.sliderInstance = new window.FoxTheme.Carousel(this, sliderOptions);
        this.sliderInstance.init();
      }
    }

    destroySlider() {
      this.classList.remove(this.classes.swiper);
      this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
      this.sliderWrapper.classList.add(this.classes.grid);
      if (typeof this.sliderInstance === 'object') {
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }
    }
  }
  customElements.define('testimonials-component', Testimonials);
}